export default [{  // 费用报销列表
	path: 'reimb',
	name: 'm_app_expense_reimbursement',
	meta: {
		title: '费用报销',
		keepAlive: true
	},
	component: () => import('@/pages/staff/finance/reimb_list')
}, {  // 费用报销详情
	path: 'reimb/detail',
	meta: {
		title: '费用报销详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/finance/reimb_detail')
}, {  // 费用报销编辑
	path: 'reimb/edit',
	meta: {
		title: '发起费用报销'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/finance/reimb_edit')
}];